import React, { Component } from 'react';
import PropTypes from 'prop-types';
import 'client/styles/pictureCard.scss';
import Card from './card';

export default class PictureCard extends Component {

  static propTypes = {
    pictureSrcs: PropTypes.arrayOf(PropTypes.string),
    pictures: PropTypes.arrayOf(PropTypes.shape({
      element: PropTypes.element,
      key: PropTypes.string,
    })),
    children: PropTypes.element,
    className: PropTypes.string,
  }

  static defaultProps = {
    pictureSrcs: [],
    pictures: null,
    children: null,
    className: null,
  }

  render() {
    const { pictureSrcs, pictures, className } = this.props;

    return (
      <div className="picture-card-container">
        <div className="picture-card">
          <div className="pictures">
            {pictures && pictures.length > 0 && pictures.map(picture => (
              <div className="picture" key={picture.key}>{picture.element}</div>
            ))}
            {!pictures && pictureSrcs.map(pictureSrc => (
              <div className="picture" key={pictureSrc}>
                <img src={pictureSrc} alt="" />
              </div>
            ))}
          </div>
          <Card shadow={false} className={className} border>
            <div className="pad-top">
              { this.props.children }
            </div>
          </Card>
        </div>
      </div>
    );
  }
}
